import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import {
  setData,
  orderAddMessage,
  orderDeleteMessage,
  orderUpMessage,
  orderDownMessage,
} from '../../../features/ecBindingSlice';
import Header from './Header';
import OrderKeyword from './OrderKeyword';
import Messages from '../../shared/Messages';

const useStyles = makeStyles(
  {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    preview: {
      width: 360,
      paddingTop: 89,
      height: 729,
    },
  },
  {
    name: 'OrderContainer',
  },
);

const OrderContainer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { data, isSaved } = useSelector(store => store.ecBinding);
  const { actions } = data || {};
  const { orderSearch } = actions || {};
  const { keyword, messages: orderSearchMessages = {} } = orderSearch || {};
  const { noOrder: messages = [] } = orderSearchMessages;

  const handleKeywordChange = value => {
    dispatch(
      setData({
        actions: {
          ...actions,
          orderSearch: {
            ...orderSearch,
            keyword: value,
          },
        },
      }),
    );
  };

  const handleMessagesChange = value => {
    dispatch(
      setData({
        actions: {
          ...actions,
          orderSearch: {
            ...orderSearch,
            messages: {
              ...orderSearchMessages,
              noOrder: value?.messages || [],
            },
          },
        },
      }),
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.setting}>
        <Header />
        <OrderKeyword
          keyword={keyword}
          onChange={handleKeywordChange}
          isSaved={isSaved}
        />
        <Messages
          title={t('ecBinding:messageNoOrder')}
          addMessage={orderAddMessage}
          deleteMessage={orderDeleteMessage}
          upMessage={orderUpMessage}
          downMessage={orderDownMessage}
          isSaved={isSaved}
          messages={messages}
          onChange={handleMessagesChange}
          platform="ig"
        />
      </div>
    </div>
  );
};

export default OrderContainer;
